/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

interface Setting {
  id: string;
  name: string;
  value: any;
}

interface SettingsState {
  settings: Setting[];
  loading: boolean;
  formLoader: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  settings: [],
  formLoader: false,
  loading: false,
  error: null,
};

export const getSettings = createAsyncThunk(
  "settings/getSettings",
  async () => {
    const response = await axiosInstance.get("/setting");
    return response.data;
  }
);

export const updateSetting = createAsyncThunk(
  "settings/updateSetting",
  async ({ id, data }: { id: string; data: any }) => {
    const response = await axiosInstance.patch(`/admin/setting/${id}`, data);
    return response.data;
  }
);

const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch settings";
      })
      .addCase(updateSetting.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.formLoader = false;
        if (action.payload) {
          state.settings = action.payload;
        }
      })
      .addCase(updateSetting.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message || "Failed to fetch settings";

      })
  },
});

export default settingSlice.reducer;
